/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsAllReviewDetailsRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.all.review.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsAllReviewDetailsRoute);
